// when the applicant checks AI/AN box, tribal state is required, followed by
//  - featured-tribes state (the enroll state): at least one tribe checkbox is required, and
//    selecting "Other" also requires the free-text tribal name.
//  - any other state (or featured-tribes disabled): the free-text tribal name is required.
export const TRIBAL_CODES = {
  STATE: 'tribal_state_required',
  NAME: 'tribal_name_required',
  TRIBE_CODE: 'tribe_code_required'
}

// isTribeMember         - the "American Indian / Alaska Native" answer
// tribalState           - selected tribal state value
// tribalName            - free-text tribal name value
// featuredTribesInState - featured tribes enabled AND selected state === enroll state
// otherTribeSelected    - the "Other" featured-tribe checkbox is checked
// anyTribeSelected      - at least one featured-tribe checkbox is checked
// returns an array of { valid, target, code } (always at least one entry)
export function validateTribal({
  isTribeMember = false,
  tribalState = "",
  tribalName = "",
  featuredTribesInState = false,
  otherTribeSelected = false,
  anyTribeSelected = false
} = {}) {
  if (!isTribeMember) return [{ valid: true, target: null, code: null }]

  // tribal state is the gate —- without it there is nothing else to validate yet.
  if (!tribalState || tribalState.trim() === "")
    return [{ valid: false, target: "tribalState", code: TRIBAL_CODES.STATE }]

  const results = []
  if (featuredTribesInState) {
    if (!anyTribeSelected)
      results.push({ valid: false, target: "tribeCodes", code: TRIBAL_CODES.TRIBE_CODE })
    if (otherTribeSelected && (!tribalName || tribalName.trim() === ""))
      results.push({ valid: false, target: "tribalName", code: TRIBAL_CODES.NAME })
  } else if (!tribalName || tribalName.trim() === "") {
    results.push({ valid: false, target: "tribalName", code: TRIBAL_CODES.NAME })
  }

  return results.length ? results : [{ valid: true, target: null, code: null }]
}
